// tokenReducer.js
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IGroups, ISites } from 'utils/models/groups';

interface GroupsState {
	groups: IGroups[];
}

const initialState: GroupsState = {
	groups: [],
};

const groups = createSlice({
	name: 'groups',
	initialState,
	reducers: {
		setGroupsInformation: (state, action: PayloadAction<IGroups[]>) => {
			state.groups = action.payload;
		},
		addGroup: (state, action: PayloadAction<IGroups>) => {
			state.groups.push(action.payload);
		},
		updateGroup: (state, action: PayloadAction<IGroups>) => {
			const index = state.groups.findIndex(group => group.id === action.payload.id);
			if (index !== -1) {
				state.groups[index] = { ...state.groups[index], ...action.payload };
			}
		},
		addSiteToGroup: (state, action: PayloadAction<{ groupId: number; site: ISites }>) => {
			const { groupId, site } = action.payload;
			const groupIndex = state.groups.findIndex(group => group.id === groupId);
			if (groupIndex !== -1) {
				if (!state.groups[groupIndex].sites) {
					state.groups[groupIndex].sites = [];
				}
				const siteExists = state.groups[groupIndex].sites!.some(
					existingSite => existingSite.id === site.id
				);
				if (!siteExists) {
					state.groups[groupIndex].sites!.push(site);
				}
			}
		},
		deleteGroup: (state, action: PayloadAction<number>) => {
			state.groups = state.groups.filter(group => group.id !== action.payload);
		},
		updateSiteInGroup: (state, action: PayloadAction<{ groupId: number; siteId: number; updates: ISites }>) => {
			const { groupId, siteId, updates } = action.payload;
			const groupIndex = state.groups.findIndex(group => group.id === groupId);
			if (groupIndex !== -1 && state?.groups[groupIndex]?.sites) {
				const siteIndex = state?.groups[groupIndex]?.sites?.findIndex((site: ISites) => site?.id === siteId);
				if (siteIndex !== -1) {
					state.groups[groupIndex].sites![siteIndex as number] = {
						...state?.groups[groupIndex]?.sites![siteIndex as number],
						...updates
					};
				}
			}
		},
		deleteSiteFromGroup: (state, action: PayloadAction<{ groupId: number; siteId: number }>) => {
			const { groupId, siteId } = action.payload;
			const groupIndex = state.groups.findIndex(group => group.id === groupId);
			if (groupIndex !== -1 && state.groups[groupIndex].sites) {
				state.groups[groupIndex] = {
					...state.groups[groupIndex],
					sites: state.groups[groupIndex].sites!.filter(
						(site: ISites) => site.id !== siteId
					)
				};
			}
		}
	},
});

export const { 
	setGroupsInformation, 
	addGroup, 
	updateGroup, 
	deleteGroup,
	addSiteToGroup,
	updateSiteInGroup,
	deleteSiteFromGroup 
} = groups.actions;

export default groups.reducer;
